module.exports = require("./fo.d.ts");